// extracted by mini-css-extract-plugin
module.exports = {"avatar_circle":"AvatarInitials--avatar_circle--1kBcD","initials":"AvatarInitials--initials--3a4VY","image":"AvatarInitials--image--TnQkc"};